import * as React from "react";
import * as ReactDOM from "react-dom";
import { Link } from "react-router-dom";

interface IProps
{
    anchorRef?: (ref: HTMLElement) => void,
    to?: string | {},
    target?: string
}

export class OptionalLink extends React.Component<IProps & React.HTMLAttributes<HTMLAnchorElement>>
{
    public render(): JSX.Element
    {
        const { anchorRef, to } = this.props;

        if (to != null)
        {
            return <Link innerRef={anchorRef} {...this.props} />
        }
        else
        {
            return <a ref={anchorRef} { ...this.props} />;
        }
    }
}